<h2 mat-dialog-title>
    {{ data?.id ? ("edit_subject" | transloco) : ("create_subject" | transloco) }}
</h2>
<mat-divider></mat-divider>
<br>
<div class="pixl-form">
    <mat-dialog-content
        [formGroup]="form"
        class="grid"
    >

        <mat-form-field class="full-width">
            <mat-label>{{ "name" | transloco }}</mat-label>
            <input
                matInput
                required
                formControlName="name"
            />
            <mat-error>{{ checkForErrors(form.controls["name"]) }}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ "application" | transloco }}</mat-label>
            <mat-select formControlName="region">
                <mat-option value="-1">{{ "no_region" | transloco }}</mat-option>
                @for (country of countries; track country) {
                <mat-option value="{{ country }}">
                    {{ country | transloco }}
                </mat-option>
                }
            </mat-select>
        </mat-form-field>

    </mat-dialog-content>
    <mat-divider></mat-divider>
    <mat-dialog-actions align="end">
        <button
            mat-button
            (click)="cancel()"
        >{{ "cancel" | transloco }}</button>
        <button
            mat-raised-button
            color="primary"
            (click)="save()"
            [disabled]="form.invalid"
        >
            {{ "save" | transloco }}
        </button>
    </mat-dialog-actions>
</div>